<nav 
    id="pcgMainNavigation" 
    class="navbar"
>
	<!-- #region Mobile header -->
     @if (
		isMobile 
		&& isLoggedOn 
		&& !onChangePasswordScreen
	) {
        <div 
            id="primaryNav" 
            class="d-flex align-items-center w-100"
        >
            <button
                aria-label="Open menu"
                [attr.aria-expanded]="this.currMainNavMenu !== ''"
                aria-controls="pcgTopClickNavEl"
                #mainHamburger
                (click)="toggleNav()"
                id="mainHamburger"
                class="btn"
            >
                <fa-icon 
                    [icon]="faBars" 
                    class="hamburger-icon"
                ></fa-icon>
            </button>
            <header 
                role="banner" 
                class="navbar-header" 
                [routerLink]="['/']"
            >
                Julio App
                @if (mode !== 'Production') { <div class="beta-text"></div> }
            </header>
        </div>
    }	
    <!-- #endregion -->

	<!--#region Secondary nav -->
    @if (
		navService.currNav() 
		&& navService.currNav().id !== 'root'
		&& !navService.currNav()?.hideSecondary
	) {
        <div 
            id="secondaryNav" 
            class="left-shift"
        >
            <div class="name-wrapper">
				<span class="current-section">{{ mainNavTitle() }}</span> <!--breadcrumbs-->
			</div>

            <!-- secondary nav items -->
            <pcg-top-secondary-nav
                role="navigation"
                aria-label="Secondary"
                [forceSelect]="currForceSelect"
                [rootNavId]="'root' + navDividerCharacter + navService.currNav()?.id?.split(navDividerCharacter)[1]"
                [routeNavId]="navService.currNav()?.id"
                [navRoutes]="navService.currNav()?.children"
                [tabPanel]="tabPanel"
                (clickedNav)="setSubNavPosition()"
            ></pcg-top-secondary-nav>
        </div>
    }
    <!--#endregion-->
</nav>